module.exports = __webpack_public_path__ + "img/enter-game.8b61b1c5.png";